<template>
    <v-layout row wrap class="contract-overview-box">
        <v-flex v-for="product in questionsable_insurnaces" :key="product.id" class="pa-2" xs12 md6>
            <v-card>
                <v-layout>
                    <v-flex class="text-xs-center pt-3" xs0 sm3>
                        <v-avatar size="75px" class="avatar"><v-icon>{{ product.icon }}</v-icon></v-avatar>
                    </v-flex>
                    <v-flex xs12 sm9>
                        <v-card-title primary-title>
                            <div>
                                <div>Haben Sie eine</div>
                                <h3 class="headline pb-2">{{ product.name }}?</h3>
                                <v-layout row wrap>
                                    <v-flex xs6>
                                        <v-btn @click="getExplanationDialog(product.id, false)" flat class="py-2 fcred--text"><v-icon color="primary" left>close</v-icon> Nein</v-btn>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn @click="getExplanationDialog(product.id, true)" flat class="py-2 fcred--text"><v-icon color="primary" left>check</v-icon> Ja</v-btn>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card-title>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>
        <v-flex v-if="show_health_insurance_question" class="pa-2" xs12 md6>
            <v-card>
                <v-layout>
                    <v-flex class="text-xs-center pt-3" xs0 sm3>
                        <v-avatar size="75px" class="avatar"><v-icon>local_hospital</v-icon></v-avatar>
                    </v-flex>
                    <v-flex xs12 sm9>
                        <v-card-title primary-title>
                            <div>
                                <div>Haben Sie eine</div>
                                <h3 class="headline pb-2">{{ last_chosen_health_insurance_kind_prewording }} Krankenversicherung?</h3>
                                <v-layout v-if="last_chosen_health_insurance_kind=='public'" row wrap>
                                    <v-flex xs6>
                                        <v-btn @click="getExplanationDialog(64, false)" flat class="py-2 fcred--text"><v-icon color="primary" left>close</v-icon> Nein</v-btn>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn @click="getExplanationDialog(64, true)" flat class="py-2 fcred--text"><v-icon color="primary" left>check</v-icon> Ja</v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-else-if="last_chosen_health_insurance_kind=='private'" row wrap>
                                    <v-flex xs6>
                                        <v-btn @click="getExplanationDialog(52, false)" flat class="py-2 fcred--text"><v-icon color="primary" left>close</v-icon> Nein</v-btn>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn @click="getExplanationDialog(52, true)" flat class="py-2 fcred--text"><v-icon color="primary" left>check</v-icon> Ja</v-btn>
                                    </v-flex>
                                </v-layout>
                                <v-layout v-else row wrap>
                                    <v-flex xs6>
                                        <v-btn @click="last_chosen_health_insurance_kind = 'public'; last_chosen_health_insurance_kind_prewording = 'gesetzliche'" flat class="py-2 fcred--text">Gesetzlich</v-btn>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-btn @click="last_chosen_health_insurance_kind = 'private'; last_chosen_health_insurance_kind_prewording = 'private'" flat class="py-2 fcred--text">Privat</v-btn>
                                    </v-flex>
                                </v-layout>
                            </div>
                        </v-card-title>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>

        <v-dialog v-model="explanation_dialog" absolute max-width="600">
            <v-card>
                <v-card-title class="headline">
                    <v-icon left>{{ explanation_icon }}</v-icon>
                    <span>{{ explanation_title }}</span>
                </v-card-title>
                <v-card-text v-html="explanation_desc" />
                <v-divider />
                <v-card-actions>
                    <v-btn flat @click="explanation_dialog = false">Abbrechen</v-btn>
                    <v-btn flat @click="setDontShowQuestionAgain">Nicht wieder anzeigen</v-btn>
                    <v-spacer />
                    <v-btn :to="explanation_url" color="black" dark>{{ explanation_button }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-layout>
</template>


<script>
import firebase from 'firebase/app';
import 'firebase/analytics';


export default {
    name: 'ContractAdditionalInsuranceQuestions',

    data () {
        return {
            questionsable_insurnaces_ids: ['34', '37', '14', '39', '59'],
            questionsable_insurnaces: [],
            explanation_dialog: false,
            explanation_title: '',
            explanation_desc: '',
            explanation_url: '',
            explanation_icon: '',
            explanation_button: '',
            explanation_id: null,
            last_chosen_health_insurance_kind: null,
            last_chosen_health_insurance_kind_prewording: '',
            show_health_insurance_question: true
        }
    },

    created(){
        if(this.$store.state.user.data.add_ins_questions){
            let add_ins_questions = this.$store.state.user.data.add_ins_questions.split(',');
            this.questionsable_insurnaces_ids = this.questionsable_insurnaces_ids.filter(questionsable_insurnaces_id => !add_ins_questions.includes(questionsable_insurnaces_id));  // filters setDontShowQuestionAgain-Contracts
            if(add_ins_questions.includes('52') || add_ins_questions.includes('64')){
                this.show_health_insurance_question = false;
            }
        }
        if(this.$store.getters['contracts/getAllContracts'].length>0){
            this.removeQuestionableInsurancesThroughContracts();
        }else{
            setTimeout(() => {
                this.removeQuestionableInsurancesThroughContracts();
            }, 2000);
        }
    },

    methods: {
        removeQuestionableInsurancesThroughContracts(){
            this.questionsable_insurnaces_ids = this.questionsable_insurnaces_ids.filter(questionsable_insurnaces_id => !this.$store.getters['contracts/getAllContracts'].find(contract => contract.product_id==questionsable_insurnaces_id));  // filters available-Contracts
            if(this.$store.getters['contracts/getAllContracts'].find(contract => (contract.product_id==64 || contract.product_id==52))){
                this.show_health_insurance_question = false;
            }
            this.loadQuestionableInsurancesData();
        },
        
        loadQuestionableInsurancesData(){
            if(this.$store.getters['products/getAllProducts'].length<5){
                this.$store.dispatch('products/loadProductData').then(products => {
                    this.questionsable_insurnaces = products.filter(product => this.questionsable_insurnaces_ids.includes(product.id));
                });
            }else{
                this.questionsable_insurnaces = this.$store.getters['products/getAllProducts'].filter(product => this.questionsable_insurnaces_ids.includes(product.id));
            };
        },

        setDontShowQuestionAgain(){
            let tmp = '';
            if(this.$store.state.user.data.add_ins_questions){
                tmp = this.$store.state.user.data.add_ins_questions+',';
            }
            if(this.explanation_id == '52' || this.explanation_id == '64'){
                this.show_health_insurance_question = false;
            }
            this.explanation_dialog = false;
            this.questionsable_insurnaces = this.questionsable_insurnaces.filter(product => product.id!=this.explanation_id);
            this.$store.dispatch('user/setUserData', { add_ins_questions: tmp+this.explanation_id });
        },

        getExplanationDialog(product_id, insurance_available){
            let insurance = this.$store.getters['products/getProductFromID'](product_id+'');
            if(this.$store.getters['user/getUsersCookieConsent']=='all'){
                firebase.analytics().logEvent('answer_is_insurance_available', { value: insurance_available, item_name: insurance.name, item_id: product_id });
            }
            if(insurance_available){
                this.explanation_title = `${insurance.name} zu VAPP hinzufügen`;
                this.explanation_desc = `<p>Wenn Sie Ihre ${insurance.name} bei VAPP hinzufügen, erhalten Sie kostenfreie Vorteile von VAPP auch für diese Police:</p>
                <ul class="checks">
                    <li>Ein Ansprechpartner für alle Fragen und Probleme</li>
                    <li>Dokumente & Vertragsdaten automatisch aktualisiert</li>
                    <li>Schadenservice - Wir sind für Sie da</li>
                    <li>Jährlicher Tarif-Check falls gewünscht</li>
                </ul>`;
                this.explanation_url = `/contract/add/${insurance.category === 'Versicherung Selbständige' ? 'company' : 'private'}/${insurance.id}/${insurance.name}`;
                this.explanation_icon = 'note_add';
                this.explanation_button = 'Jetzt eintragen';
            }else{
                this.explanation_title = `Wozu eine ${insurance.name}?`;
                this.explanation_desc = `<p>${insurance.description}</p>
                <p>Fordern Sie jetzt ein kostenfreies, unabhängiges und unverbindliches Angebot für eine ${insurance.name} an und profitieren Sie von günstigen Kombiangeboten, exklusiven Rabatten und für Sie individuell handverlesende Angebote von unseren Mitarbeitern.</p>`;
                this.explanation_url = `/offer/add/${insurance.category === 'Versicherung Selbständige' ? 'company' : 'private'}/${insurance.id}?show_offer_dialog=1`;
                this.explanation_icon = 'plagiarism';
                this.explanation_button = 'Angebot anfordern';
            }
            this.explanation_id = product_id;
            this.explanation_dialog = true;
        }
    }
}
</script>


<style scoped>
    h3.headline{
        word-break: break-word;
    }
    .v-card__title--primary > *{
        width: 100%;
    }


    @media screen and (max-width: 576px) {
        .v-card > .layout{
            flex-direction: column;
            text-align: center;
        }
        .v-card .layout > .xs0{
            padding-top: 16px;
        }
        h3.headline, .v-card__title h3.headline{
            word-break: break-all;
            font-size: 16px!important;
        }
        .v-card__title > span{
            font-size: 16px;
        }
        .contract-overview-box .v-avatar .v-icon {
            font-size: 5rem;
        }
    }
</style>